import React, { useState, useEffect } from "react";
import css from './OnboardingModal.module.css'
import MissingInfoModal from "./MissingInfoModal";
import ProfileModal from "./ProfileModal";
import UploadPassportModal from "./UploadPassportModal";
import ConfirmModal from "./ConfirmModal";
import { useConfiguration } from "../../context/configurationContext";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck'

const OnboardingModalComponent = props => {
    const {
        onManageDisableScrolling,
        currentUser,
        onUpdateProfile,
        updateInProgress,
        isFromCreateListing,
        // emailverified,
        out = false,
        setOut = () => { },
    } = props;
    const [isMissingInfoModalOpen, setIsMissingInfoModalOpen] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isUploadPassportOpen, setIsUploadPassportOpen] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
    const user = ensureCurrentUser(currentUser);
    const { publicData } = user?.attributes.profile;
    const config = useConfiguration();
    const { userFields } = config?.user;

    const onCloseModal = () => {
        setIsMissingInfoModalOpen(false);
        setOut(false);
    }

    const userfieldkeys = userFields.map(field => field.key)

    const missingFields = userfieldkeys.filter(key => {
        // if (!publicData?.[key]) {
        //     console.log('Missing field for key:', key);
        // }
        return !publicData?.[key];
    });
    const showOnboarding = typeof window !== 'undefined' && window.localStorage.getItem('showOnboarding') === 'true';
    const uploadedRequested = typeof window !== 'undefined' && window.localStorage.getItem('uploadedRequested') === 'true';

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isFirstSignUp = typeof window !== 'undefined' && window.localStorage.getItem('firstSignUp') === 'true';
            const passportUploaded = typeof window !== 'undefined' && window.localStorage.getItem('passportUploaded') === 'true';

            if (passportUploaded) {
                setIsConfirmModalOpen(true);
                typeof window !== 'undefined' && window.localStorage.removeItem('passportUploaded');
            }
            if (isFirstSignUp && missingFields && missingFields.length > 0) {
                setIsMissingInfoModalOpen(true);
                typeof window !== 'undefined' && window.localStorage.removeItem('firstSignUp');
            }
            if (showOnboarding) {
                setIsMissingInfoModalOpen(true);
                typeof window !== 'undefined' && window.localStorage.removeItem('showOnboarding');
            }
            if (uploadedRequested) {
                setIsUploadPassportOpen(true);
                typeof window !== 'undefined' && window.localStorage.removeItem('uploadedRequested');
            }
            if (isFromCreateListing && missingFields && missingFields.length > 0) {
                setIsMissingInfoModalOpen(true);
            }
        }
    }, [out]);

    return (
        <>
            <MissingInfoModal
                isMissingInfoModalOpen={isMissingInfoModalOpen}
                setIsMissingInfoModalOpen={onCloseModal}
                onManageDisableScrolling={onManageDisableScrolling}
                setIsProfileModalOpen={setIsProfileModalOpen}
                isFromCreateListing={isFromCreateListing}
            />

            {isProfileModalOpen ? <ProfileModal
                isProfileModalOpen={isProfileModalOpen}
                setIsProfileModalOpen={setIsProfileModalOpen}
                onManageDisableScrolling={onManageDisableScrolling}
                config={config}
                user={user}
                setIsUploadPassportOpen={setIsUploadPassportOpen}
                isFromCreateListing={isFromCreateListing}
            /> : null}

            {isUploadPassportOpen ? <UploadPassportModal
                user={user}
                onManageDisableScrolling={onManageDisableScrolling}
                setIsUploadPassportOpen={setIsUploadPassportOpen}
                onUpdateProfile={onUpdateProfile}
                isUploadPassportOpen={isUploadPassportOpen}
                setIsConfirmModalOpen={setIsConfirmModalOpen}
                updateInProgress={updateInProgress}
            /> : null}

            {isConfirmModalOpen ? <ConfirmModal
                onManageDisableScrolling={onManageDisableScrolling}
                setIsConfirmModalOpen={setIsConfirmModalOpen}
                isConfirmModalOpen={isConfirmModalOpen}
            /> : null}


        </>
    );
};

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const {
        updateInProgress,
        updateProfileError,
    } = state.ProfileSettingsPage;
    return {
        currentUser,
        // scrollingDisabled: isScrollingDisabled(state),
        updateInProgress,
        updateProfileError,
    };
};

const mapDispatchToProps = dispatch => ({
    onUpdateProfile: data => dispatch(updateProfile(data)),
});
const OnboardingModal = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    injectIntl
)(OnboardingModalComponent);
export default OnboardingModal;
